(function handleContactForm() {

    if (document.getElementById("contact-form")) {
        var nameRegex = /^[a-zA-ZàáâäãåąæčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄÆĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/;
        var phoneRegex = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/;
        var emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        var textRegex = /^[0-9a-zA-ZàáâäãåąæčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄÆĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.?!'-]+$/;
        var subjectRegex = /[$%^*_\[\]{};'\\|<>]/;

        new Vue({
            el: "#contact-form",
            data: {
                categories: [],
                email: "",
                name: "",
                phoneNumber: "",
                title: "",
                inquiry: "",
                warningText: "",
                customerNumber: null,
                selectedCategory: null,
                selectedSubcategory: null,
                categoryFields: [],
                subCategoryFields: [],
                appReady: false,
                extraFields: {},
                errors: {
                    name: "",
                    email: "",
                    inquiry: "",
                    phone: "",
                    title: "",
                    gdpr: "",
                    network: ""
                },
                tempErrors: {},
                strings: {},
                action: "/infocenter/_api/customerContact/SendEmail",
                storeId: "",
                language: "",
                gdprConsent: false,
                isDone: false,
                isSending: false,
                formStarted: false,
            },
            mounted: function () {
                var contactModel = JSON.parse($(".contact-form").attr("data-model"));
                this.categories = contactModel.categories;
                this.strings = contactModel.contactStrings;
                this.storeId = contactModel.storeId;
                this.language = contactModel.language;

                var customerDetails = this.getCustomerDetails();
                this.customerNumber = customerDetails.accountNumber ? customerDetails.accountNumber: null;

                this.mapFormFields(customerDetails);

                this.appReady = true;

                window.addEventListener("unload", this.saveForm.bind(this));
            },
            computed: {
                hasSubcategories: function() {
                    return this.selectedCategory && this.selectedCategory.subCategories.length > 0;
                },
                hasChosenFinalCategory: function() {
                    return this.selectedCategory !== null && (this.selectedSubcategory !== null || !this.hasSubcategories);
                }
            },
            methods: {
                startForm: function () {
                    if (this.formStarted === false) {
                      this.formStarted = true;
                      this.trackToGa("form_focus");
                    }
                  },
                categoryChanged: function() {
                    this.selectedSubcategory = null;
                    this.categoryFields = this.selectedCategory ? this.selectedCategory.fields : [];
                    this.subCategoryFields = [];
                    this.warningText = "";

                    for (var property in this.errors) {
                        this.$set(this.errors, property, "");
                    }

                    for (var i = 0; i < this.categoryFields.length; i++) {
                        var field = this.categoryFields[i];
                        this.$set(this.extraFields, field.name, "");
                        this.$set(this.errors, field.name, "");
                    }
                },
                subCategoryChanged: function () {
                    this.subCategoryFields = this.selectedSubcategory ? this.selectedSubcategory.fields : [];
                    this.warningText = this.selectedSubcategory ? this.selectedSubcategory.warningText : "";

                    for (var property in this.errors) {
                        this.$set(this.errors, property, "");
                    }

                    for (var i = 0; i < this.subCategoryFields.length; i++) {
                        var field = this.subCategoryFields[i];
                        this.$set(this.extraFields, field.name, "");
                        this.$set(this.errors, field.name, "");
                    }
                },
                checkName: function () {               
                    if (this.name === "" || !nameRegex.test(this.name)) {
                        this.tempErrors.name = this.strings.requiredError.replace("{field}", this.strings.name);
                        return false;
                    }
                    return true;
                },
                checkPhone: function() {
                    if (this.phoneNumber !== "" && !phoneRegex.test(this.phoneNumber)) {
                        this.tempErrors.phone = this.strings.invalidError.replace("{field}", this.strings.phone);
                        return false;
                    }
                    return true;
                },
                checkEmail: function() {
                    if (this.email === "" || !emailRegex.test(this.email)) {
                        this.tempErrors.email = this.strings.requiredError.replace("{field}", this.strings.email);
                        return false;
                    }
                    return true;
                },
                checkTitle: function () {
                    if (this.title === "" || !textRegex.test(this.title)) {
                        this.tempErrors.title = this.strings.requiredError.replace("{field}", this.strings.subjectTitel);
                        return false;
                    }
                    return true;
                },
                checkSubject: function () {
                    if (this.inquiry === "" || subjectRegex.test(this.inquiry)) {
                        this.tempErrors.inquiry = this.strings.requiredError.replace("{field}", this.strings.subject);
                        return false;
                    }
                    return true;
                },
                checkExtraFields: function (value) {
                    if (value.isMandatory) {
                        if (this.extraFields[value.name] === "" || !textRegex.test(this.extraFields[value.name])) {
                            this.tempErrors[value.name] = this.strings.requiredError.replace("{field}", value.name);
                            return false;
                        }
                    } else if (this.extraFields[value.name] !== "" && !textRegex.test(this.extraFields[value.name])) {
                        this.tempErrors[value.name] = this.strings.invalidError.replace("{field}", value.name);
                        return false;
                    }

                    return true;
                },
                checkAllExtraFields: function (accumulator, currentValue) {
                    var currentCheck = this.checkExtraFields(currentValue);

                    return currentCheck && accumulator;
                },
                checkAllFields: function () {
                    var nameIsValid = this.checkName();
                    var phoneIsValid = this.checkPhone();
                    var emailIsValid = this.checkEmail();
                    var titleIsValid = this.checkTitle();
                    var subjectIsValid = this.checkSubject();
                    var extraCategoryFieldsAreValid = this.categoryFields.reduce(this.checkAllExtraFields, true);
                    var extraSubCategoryFieldsAreValid = this.subCategoryFields.reduce(this.checkAllExtraFields, true);

                    if (!this.gdprConsent) {
                        this.tempErrors.gdpr = "error";
                    }

                    return nameIsValid && phoneIsValid && emailIsValid && titleIsValid && subjectIsValid && extraCategoryFieldsAreValid && extraSubCategoryFieldsAreValid && this.gdprConsent;
                },
                checkForm: function () {
                    for (var property in this.tempErrors) {
                        this.tempErrors[property] = "";
                    }

                    if (this.checkAllFields()) {
                        if (!this.isSending) {
                            this.sendForm();
                        } else {
                            return;
                        }    
                    } 
                        
                    this.errors = Object.assign({},
                        this.errors,
                        this.tempErrors);
                    
                },
                sendForm: function () {
                    this.isSending = true;

                    var formData = new FormData();
                    formData.append("SubjectCategory", this.selectedCategory.name);
                    if (this.selectedSubcategory) formData.append("SubjectSubcategory", this.selectedSubcategory.name);
                    formData.append("CustomerName", this.name);
                    formData.append("PhoneNumber", this.phoneNumber);
                    formData.append("Email", this.email);
                    formData.append("SubjectTitle", this.title);
                    formData.append("SubjectText", this.inquiry);
                    formData.append("StoreId", this.storeId);
                    formData.append("Language", this.language);
                    formData.append("CustomerNumber", this.customerNumber);                     
                    
                    var files = this.$refs["files"].files;
                    for (var i = 0; i < files.length; i++) {
                        var file = files[i];
                        formData.append("AttachedFiles" + i, file, file.name);
                    }

                    var fields = {};
                    for (var j = 0; j < this.categoryFields.length; j++) {
                        var propertyName = this.categoryFields[j].name;
                        var proprtyValue = this.extraFields[propertyName];
                        fields[propertyName] = proprtyValue;
                    }
                    for (var k = 0; k < this.subCategoryFields.length; k++) {
                        var subPropertyName = this.subCategoryFields[k].name;
                        var subProprtyValue = this.extraFields[subPropertyName];
                        fields[subPropertyName] = subProprtyValue;
                    }
                    formData.append("AdditionalFieldsString", JSON.stringify(fields));

                    var fetchOptions = {
                        method: "POST",
                        body: formData
                    };

                    var responsePromise = fetch(this.action, fetchOptions);
                    responsePromise.then(function (response) {
                        if (!response.ok) {
                            this.errors.network = "error";
                            this.isSending = false;
                            throw new Error('Network response was not ok.');
                        } else {
                            this.trackToGa("form_submit");
                            this.isDone = true;
                            this.isSending = false;
                            localStorage.removeItem("ContactForm" + this.storeId);
                        }
                    }.bind(this)).catch(function (error) {
                        console.error(error);
                        this.isSending = false;
                    }.bind(this));
                },
                trackToGa: function (eventType) {
                    window.dataLayer = window.dataLayer || [];
          
                    if (eventType === "form_submit") {
                      window.dataLayer.push({
                        event: eventType,
                        form_category: this.selectedCategory.name,
                        form_subcategory: this.selectedSubcategory.name,
                      });
                    } else {
                      window.dataLayer.push({
                        event: eventType,
                      });
                    }
                  },
                saveForm: function () {
                    if (!this.isDone) {
                        var form = {
                            category: this.selectedCategory ? this.selectedCategory.name : "",
                            subcategory: this.selectedSubcategory ? this.selectedSubcategory.name : "",
                            name: this.name,
                            email: this.email,
                            phoneNumber: this.phoneNumber,
                            title: this.title,
                            inquiry: this.inquiry,
                            extraFields: this.extraFields
                        };

                        try {
                            localStorage.setItem("ContactForm" + this.storeId, JSON.stringify(form));
                        }
                        catch (e) {
                            console.error("Cant save form: " + e);
                        }
                    }
                }, 
                mapFormFields: function (customerDetails) {
                    var storedContactForm = localStorage.getItem("ContactForm" + this.storeId);
                    var savedForm = storedContactForm ? JSON.parse(storedContactForm) : {};

                    this.email = savedForm.email && savedForm.email.length > 0 ? savedForm.email : customerDetails.email ? customerDetails.email : "";
                    this.name = savedForm.name && savedForm.name.length > 0 ? savedForm.name : customerDetails.name ? customerDetails.name : "";
                    this.phoneNumber = savedForm.phoneNumber && savedForm.phoneNumber.length > 0 ? savedForm.phoneNumber : "";
                    this.title = savedForm.title && savedForm.title.length > 0 ? savedForm.title : "";
                    this.inquiry = savedForm.inquiry && savedForm.inquiry.length > 0 ? savedForm.inquiry : "";

                    if (savedForm.category && savedForm.category.length > 0) {
                        var foundCategory = this.categories.find(function (element) {
                            return element.name === savedForm.category;
                        });

                        if (foundCategory) {
                            this.selectedCategory = foundCategory;
                            this.categoryChanged();

                            if (savedForm.subcategory && savedForm.subcategory.length > 0) {
                                var foundSubcategory = foundCategory.subCategories.find(function (element) {
                                    return element.name === savedForm.subcategory;
                                });

                                if (foundSubcategory) {
                                    this.selectedSubcategory = foundSubcategory;
                                    this.subCategoryChanged();
                                }
                            }

                            this.extraFields = savedForm.extraFields ? savedForm.extraFields : {};
                        }
                    }
                },
                getCustomerDetails: function() {
                    const cookieValue = this.getCookieValue("Komplett.Caas.Session");

                    if (cookieValue != null) {
                        const base64Url = cookieValue.indexOf(".") > -1 ? cookieValue.split(".")[1] : string;
                        const base64 = base64Url.replace("-", "+").replace("_", "/");
                        const decodedCookie = JSON.parse(atob(base64));

                        return {
                            name: decodedCookie["cn"],
                            email: decodedCookie["usn"],
                            accountNumber: decodedCookie["aid"]
                        }
                    } else {
                        return { }
                    }
                },
                getCookieValue: function(key) {
                    return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" +
                                encodeURIComponent(key).replace(/[\-\.\+\*]/g, "\\$&") +
                                "\\s*\\=\\s*([^;]*).*$)|^.*$"),"$1")) || null;
                }
            }
        });
    }
})();